import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import withMatch from '@/hocs/withMatch';
import Link from '@/components/atoms/Link';
import { connect } from 'react-redux';
import get from 'lodash.get';
import { getResultData } from '../redux/apiData';
import getLinkFromPageObject from '../services/getLinkFromPageObject';
import { hasSubmenu } from '../redux/menu';
import { WidthLimit } from '../styles/gridElements';
import { fonts, colorPalette } from '../styles/styleGuide';
import { fromBreakpoint } from '../styles/breakpoints';
import Caret from './shared/icons/Caret';
import FlyOutMenu from './FlyOutMenu';
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    styling: get(getResultData(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'styling', {})
  };
};
var findMenuItemBySlug = function findMenuItemBySlug(slug, menuItems) {
  return menuItems.find(function (menuItem) {
    return menuItem.slug === slug;
  });
};
var Menu = /*#__PURE__*/function (_Component) {
  function Menu() {
    var _this;
    _classCallCheck(this, Menu);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Menu, [].concat(args));
    _defineProperty(_this, "menuItemsObject", {});
    _defineProperty(_this, "state", {
      hoverMenuSlug: '',
      moreMenuItems: []
    });
    return _this;
  }
  _inherits(Menu, _Component);
  return _createClass(Menu, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var oldPagePath = getLinkFromPageObject(prevProps.match.params);
      var newPagePath = getLinkFromPageObject(this.props.match.params);
      if (oldPagePath !== newPagePath) {
        this.setState({
          hoverMenuSlug: ''
        });
      }
    }
  }, {
    key: "calculateMenu",
    value: function calculateMenu() {
      var _this2 = this;
      // Calculate if the width of all menu items is bigger than wrapper, if so: add a 'more' menu section

      // Calculate width of all menu items
      if (this.menuItemsObject && Object.keys(this.menuItemsObject).length > 0) {
        var fullWidth = Object.values(this.menuItemsObject).reduce(function (start, value) {
          return start + (value.clientWidth + 50); // 50 for the margin
        }, 0);

        // if width of all items > than the menuwrapper (space available): add 'more' menu item
        if (this.menuWrapper && this.menuWrapper.clientWidth < fullWidth) {
          var moreItems = [];
          var newWidth = fullWidth;
          Object.values(this.menuItemsObject).reverse().forEach(function (value) {
            if (newWidth >= fullWidth) {
              newWidth = newWidth - (value.clientWidth + 50);
              moreItems.push(value);
            }
          });
          if (moreItems.length > 0) {
            this.setState(function (prevState) {
              return _objectSpread(_objectSpread({}, prevState), {}, {
                moreMenuItems: _this2.props.menuItems.slice(_this2.props.menuItems.length - (moreItems.length + 1))
              });
            });
          }
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.calculateMenu);
      this.calculateMenu();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.calculateMenu);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        styling = _this$props.styling,
        _this$props$menuItems = _this$props.menuItems,
        menuItems = _this$props$menuItems === void 0 ? [] : _this$props$menuItems,
        match = _this$props.match;
      var _this$state = this.state,
        hoverMenuSlug = _this$state.hoverMenuSlug,
        moreMenuItems = _this$state.moreMenuItems;
      var _match$params = match.params,
        projectSlug = _match$params.projectSlug,
        env = _match$params.env,
        menuSlug = _match$params.menuSlug,
        pageSlug = _match$params.pageSlug;
      var filteredMenuItems = menuItems.filter(function (item) {
        return !item.hidden;
      });
      var currentMenuItem = menuSlug ? findMenuItemBySlug(menuSlug, filteredMenuItems) : undefined;
      var moreSectionIsActive = moreMenuItems && moreMenuItems.length > 0 ? filteredMenuItems.slice(filteredMenuItems.length - moreMenuItems.length).find(function (item) {
        return item.slug === (currentMenuItem && currentMenuItem.slug);
      }) : -1;
      var activeMenuColor = styling.navActiveLabel && env === 'open' ? styling.navActiveLabel : colorPalette.blue;
      return __jsx(Container, {
        ref: function ref(el) {
          _this3.menuWrapper = el;
        },
        "data-e2e-menu-container": true,
        onMouseLeave: function onMouseLeave() {
          return _this3.setState({
            hoverMenuSlug: ''
          });
        },
        "data-id": "components_Menu_Container"
      }, __jsx(MenuItemWrapper, {
        "data-id": "components_Menu_MenuItemWrapper"
      }, (moreMenuItems && moreMenuItems.length > 0 ? filteredMenuItems.slice(0, filteredMenuItems.length - moreMenuItems.length) : filteredMenuItems).map(function (menuItem, index) {
        var isCurrentMenu = menuItem.slug === menuSlug || !menuSlug && index === 0;
        var isHovered = menuItem.slug === hoverMenuSlug;
        var options = hasSubmenu(menuItem) ? menuItem.pages && menuItem.pages.map(function (page) {
          return {
            name: page.name,
            label: page.name,
            type: 'menu',
            active: menuSlug === menuItem.slug && pageSlug === page.slug,
            hidden: page.hidden,
            link: '/' + getLinkFromPageObject({
              projectSlug: projectSlug,
              env: menuItem.env,
              menuSlug: menuItem.slug,
              pageSlug: page.slug
            })
          };
        }) : undefined;
        return !menuItem.hidden ? __jsx(React.Fragment, {
          key: menuItem.slug
        }, __jsx(MenuItem, {
          ref: function ref(el) {
            _this3.menuItemsObject[index] = el;
          },
          "data-id": "components_Menu_MenuItem"
        }, hasSubmenu(menuItem) ? __jsx(MenuButton, {
          key: menuItem.slug,
          onClick: function onClick() {
            return _this3.setState({
              hoverMenuSlug: isHovered ? '' : menuItem.slug
            });
          },
          color: isCurrentMenu || isHovered ? activeMenuColor : colorPalette.headerGrey,
          "data-id": "components_Menu_MenuButton"
        }, menuItem.name, __jsx(CaretContainer, {
          isActive: isHovered,
          "data-id": "components_Menu_CaretContainer"
        }, __jsx(Caret, {
          direction: "down",
          color: isCurrentMenu || isHovered ? String(activeMenuColor) : String(colorPalette.headerGrey),
          "data-id": "components_Menu_Caret"
        }))) : __jsx(MenuLink, {
          href: '/' + getLinkFromPageObject({
            projectSlug: projectSlug,
            env: menuItem.env,
            menuSlug: menuItem.slug
          }),
          color: isCurrentMenu || isHovered ? activeMenuColor : colorPalette.headerGrey,
          "data-id": "components_Menu_MenuLink"
        }, menuItem.name)), hasSubmenu(menuItem) && options && __jsx(FlyOutMenu, {
          visible: isHovered,
          projectSlug: String(projectSlug),
          options: options,
          target: _this3.menuItemsObject[index],
          position: "bottom",
          "data-id": "components_Menu_FlyOutMenu"
        })) : null;
      }), moreMenuItems && moreMenuItems.length > 0 && __jsx(React.Fragment, null, __jsx(MoreButton, {
        onClick: function onClick() {
          return _this3.setState({
            hoverMenuSlug: hoverMenuSlug === 'more' ? '' : 'more'
          });
        },
        color: hoverMenuSlug === 'more' || moreSectionIsActive ? activeMenuColor : colorPalette.headerGrey,
        ref: function ref(el) {
          _this3.moreButton = el;
        },
        "data-id": "components_Menu_MoreButton"
      }, "Meer...", __jsx(CaretContainer, {
        isActive: hoverMenuSlug === 'more' || moreSectionIsActive,
        "data-id": "components_Menu_CaretContainer"
      }, __jsx(Caret, {
        direction: "down",
        color: hoverMenuSlug === 'more' || moreSectionIsActive ? String(activeMenuColor) : String(colorPalette.headerGrey),
        "data-id": "components_Menu_Caret"
      }))), __jsx(FlyOutMenu, {
        visible: hoverMenuSlug === 'more',
        projectSlug: String(projectSlug),
        options: filteredMenuItems.slice(filteredMenuItems.length - moreMenuItems.length).map(function (menuItem) {
          return {
            name: menuItem.name,
            label: menuItem.name,
            type: 'menu',
            active: menuSlug === menuItem.slug,
            subLinks: hasSubmenu(menuItem) ? menuItem.pages && menuItem.pages.map(function (page) {
              return {
                label: page.name,
                active: menuSlug === menuItem.slug && pageSlug === page.slug,
                hidden: page.hidden,
                link: '/' + getLinkFromPageObject({
                  projectSlug: projectSlug,
                  env: menuItem.env,
                  menuSlug: menuItem.slug,
                  pageSlug: page.slug
                })
              };
            }) : undefined,
            link: '/' + getLinkFromPageObject({
              projectSlug: projectSlug,
              env: menuItem.env,
              menuSlug: menuItem.slug
            })
          };
        }),
        target: this.moreButton,
        position: "bottom",
        "data-id": "components_Menu_FlyOutMenu"
      }))), __jsx(SubmenuBackground, {
        visible: !!currentMenuItem && hasSubmenu(currentMenuItem),
        "data-id": "components_Menu_SubmenuBackground"
      }, filteredMenuItems.map(function (menuItem) {
        return hasSubmenu(menuItem) && __jsx(SubmenuBar, {
          key: menuItem.slug,
          visible: menuSlug === menuItem.slug,
          "data-e2e-menu-submenubar": menuItem.slug,
          "data-id": "components_Menu_SubmenuBar"
        }, __jsx(SubmenuWidthLimit, {
          "data-id": "components_Menu_SubmenuWidthLimit"
        }, __jsx(SubmenuMarginFix, {
          "data-id": "components_Menu_SubmenuMarginFix"
        }, menuItem.pages && menuItem.pages.map(function (submenuItem) {
          return !submenuItem.hidden ? __jsx(SubmenuItemLink, {
            href: '/' + getLinkFromPageObject({
              projectSlug: projectSlug,
              env: submenuItem.env,
              menuSlug: menuItem.slug,
              pageSlug: submenuItem.slug
            }),
            key: submenuItem.slug || 'home',
            color: activeMenuColor,
            style: {
              borderBottomColor: menuSlug === menuItem.slug && pageSlug === submenuItem.slug ? activeMenuColor : ''
            },
            "data-id": "components_Menu_SubmenuItemLink"
          }, submenuItem.name) : null;
        }))));
      })));
    }
  }]);
}(Component);
export default withMatch(connect(mapStateToProps)(Menu));
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: none;\n\n  @media only all and (min-width: 1040px) {\n    display: flex;\n    justify-content: flex-end;\n    max-height: 68rem;\n  }\n"])));
var MenuItemWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  text-align: right;\n  overflow: hidden;\n"])));
var MenuItem = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: inline-block;\n  margin: 0 0 22rem 30rem;\n\n  ", ";\n\n  ", ";\n"])), fromBreakpoint.lg(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    margin-left: 40rem;\n  "]))), fromBreakpoint.slg(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    margin-left: 50rem;\n  "]))));
var sharedMenuStyles = function sharedMenuStyles(color) {
  return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  font-size: 18rem;\n  text-transform: uppercase;\n  font-weight: bold;\n  padding: 20rem 0 0;\n  font-family: ", ";\n  text-decoration: none;\n  color: ", ";\n  cursor: pointer;\n\n  &:hover {\n    color: ", ";\n\n    > span > svg > g {\n      fill: ", ";\n    }\n  }\n"])), fonts.primary, color, colorPalette.blue, colorPalette.blue);
};
var MenuButton = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref) {
  var color = _ref.color;
  return sharedMenuStyles(color);
});
var MoreButton = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", ";\n\n  margin-left: 30rem;\n\n  ", ";\n\n  ", ";\n"])), function (_ref2) {
  var color = _ref2.color;
  return sharedMenuStyles(color);
}, fromBreakpoint.lg(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    margin-left: 40rem;\n  "]))), fromBreakpoint.slg(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n    margin-left: 50rem;\n  "]))));
var MenuLink = styled(Link)(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref3) {
  var color = _ref3.color;
  return sharedMenuStyles(color);
});
var CaretContainer = styled.span(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: inline-block;\n  margin-left: 10rem;\n  line-height: 9rem;\n  vertical-align: 10%;\n  transform: rotateX(", "deg);\n  transition: transform 0.25s;\n"])), function (props) {
  return props.isActive ? 180 : 0;
});

// The background prevents see-through when transitioning opacity
var SubmenuBackground = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: #f1f0ef;\n  height: 35rem;\n  opacity: ", ";\n  transition: opacity 0.2s;\n"])), function (props) {
  return props.visible ? 1 : 0;
});
var SubmenuBar = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  background: #f1f0ef;\n  transition: opacity 0.2s;\n  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.12);\n  opacity: ", ";\n  z-index: ", ";\n  ", ";\n"])), function (props) {
  return props.visible ? 1 : 0;
}, function (props) {
  return props.visible ? 0 : 0;
}, function (props) {
  return !props.visible ? 'pointer-events: none;' : '';
});

// clip margin fixer
var SubmenuWidthLimit = styled(WidthLimit)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  overflow: hidden;\n"])));
var SubmenuMarginFix = styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  margin-left: -5rem;\n  margin-right: -5rem;\n  display: flex;\n  flex-wrap: wrap;\n"])));
var SubmenuItemLink = styled(Link)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  font-weight: normal;\n  text-transform: none;\n  line-height: 27rem;\n  padding-bottom: 0;\n  font-family: ", ";\n  font-size: 18rem;\n  color: ", ";\n  &:hover {\n    color: ", ";\n  }\n  margin-left: 25rem;\n  margin-right: 25rem;\n  border-bottom: 4rem solid transparent;\n  padding-top: 4rem;\n  text-decoration: none;\n"])), fonts.primary, colorPalette.headerGrey, function (props) {
  return props.color;
});